import React from "react";
import { Grid } from "@material-ui/core";

import StoreVsComparatorRankedGrossProfit from "./StoreVsComparatorRankedGrossProfit";
import RollingGrossProfit from "./RollingGrossProfit";

const ProductCategoryGrowth = () => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <StoreVsComparatorRankedGrossProfit />
            </Grid>
            <Grid item xs={12}>
                <RollingGrossProfit />
            </Grid>
        </Grid>
    );
};

export default ProductCategoryGrowth;
